import type { RowActionsSourceOptions } from '@cli-types/next-adapter/generators.js'
import { escapeTemplateText } from '@cli-utils/text.js'
import { escapeJsx } from '@cli-utils/text.js'
import { renderBuildRowActionsSourceClientModuleTemplate } from '@next-adapter/templates/renderers/generators/row-actions-emitters/build-row-actions-source.js'

export function buildRowActionsSource({
  componentName,
  dialogComponentName,
  dialogModuleName,
  noun
}: RowActionsSourceOptions): string {
  return renderBuildRowActionsSourceClientModuleTemplate({
    dialogComponentName: dialogComponentName,
    dialogModuleName: dialogModuleName,
    componentName: componentName,
    escapeTemplateText: escapeTemplateText(noun),
    escapeJsx: escapeJsx(noun)
  })
}
